module.exports = "<div [hidden]=\"!active\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/tabs/tab/tab.component.html
// module id = ../../../../../src/app/shared/tabs/tab/tab.component.html
// module chunks = 2